// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		addParams:{},
		saleManIdList:[],
		times:0,
		money:0,
		remark:'',
	},
	getters: {
		
	},
	mutations: {
		set_addParams(state, obj) {
			state.addParams = obj;
		},
		set_saleManIdList(state, obj) {
			state.saleManIdList = obj;
		},
		set_times(state, obj) {
			state.times = obj;
		},
		set_money(state, params) {
			state.money = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
	},
	actions: {

	},
};
